const NoNo = (props) => {


    return (
        <div>nono</div>
    )
}


export default NoNo;